import {
  Sidebar,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import { NavDivider } from './NavDivider';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import TimelineIcon from '@material-ui/icons/Timeline';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import { ActionableWebNotifications } from '../webNotifications';
import {
  EphemeralEnvsSidebarItem,
  MyWorkSidebarItem,
} from '@internal/backstage-plugin-dev-home';
import { RdsAdminSidebarItem } from '@internal/backstage-plugin-rds-admin';
import { IncidentsSidebarItem } from '@internal/backstage-plugin-platform-pipeline';

/** The extension tree viewer is a developer tool: not in the production menu. */
const SHOW_DEV_TOOLS = process.env.NODE_ENV !== 'production';

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ));

      // Skipped items
      nav.take('page:search'); // Using search modal instead
      nav.take('page:notifications'); // Rendered as the bell at the bottom
      nav.take('page:platform-pipeline/ephemeral-envs'); // Rendered manually next to Bases de données
      nav.take('page:platform-pipeline/incidents'); // Rendered manually with its open count
      nav.take('page:delivery'); // Rendered manually below
      nav.take('page:productivity'); // Rendered manually next to Livraison
      nav.take('page:dev-home/my-work'); // Rendered manually with its to-do count
      nav.take('page:rds-admin'); // Rendered manually, to the users who may read a cluster
      const visualizer = nav.take('page:app-visualizer'); // Developer tool: shown outside production only

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarGroup label="Recherche" icon={<SearchIcon />} to="/search">
            <SidebarSearchModal />
          </SidebarGroup>
          <NavDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            {nav.take('page:dev-home')}
            <MyWorkSidebarItem />
            {nav.take('page:catalog')}
            {nav.take('page:scaffolder')}
            <RdsAdminSidebarItem />
            <EphemeralEnvsSidebarItem />
            <IncidentsSidebarItem />
            <SidebarItem icon={LocalShippingIcon} to="/delivery" text="Livraison" />
            <SidebarItem
              icon={TimelineIcon}
              to="/productivity"
              text="Productivité"
            />
            <NavDivider />
            <SidebarScrollWrapper>
              {nav.rest({ sortBy: 'title' })}
            </SidebarScrollWrapper>
          </SidebarGroup>
          <SidebarSpace />
          <NavDivider />
          <NotificationsSidebarItem titleCounterEnabled />
          <ActionableWebNotifications />
          <NavDivider />
          <SidebarGroup
            label="Paramètres"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {SHOW_DEV_TOOLS ? visualizer : null}
            {nav.take('page:analytics')}
            {nav.take('page:user-settings')}
          </SidebarGroup>
        </Sidebar>
      );
    },
  },
});
